//@flow
import React from 'react';
import {Link} from 'react-router-dom';

import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import SwitchableSection from '../../../../../elements/SwitchableSection';
import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import {useFeaturedProducts} from '../../../../products/utils/hooks';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  disabledRoot: {
    background: colors.grey300,
  },
}));

type Props = {
  sectionEnabled?: boolean,
};

export default function FeaturedProducts(props: Props) {
  const {sectionEnabled} = props;

  const classes = useStyles();
  const featuredProducts = useFeaturedProducts();

  const emptyContent = !featuredProducts?.length;
  return (
    <SwitchableSection
      id={HOME_PAGE_SECTION_NAMES.FEATURED_PRODUCTS}
      title="Elementos destacados"
      subtitle="Selecciona 3 o 6 Elementos destacados de tus catálogo activando la estrella en la esquina inferior derecha."
      classes={{
        root: emptyContent || !sectionEnabled ? classes.disabledRoot : '',
      }}
    >
      <CustomButton variant="contained" to="/products" component={Link}>
        Destacar elemento
      </CustomButton>
    </SwitchableSection>
  );
}
